import { Box, Button, Typography } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { config } from 'style-config';

const getButtonSxByPath = (path: string, expectedPath: string) => {
  return {
    color: path === expectedPath ? config.MainColor : 'white',
    backgroundColor: path === expectedPath ? 'white' : config.MainColor,
    height: '100%',
    textDecoration: 'none',
  };
};

const HeaderLinkButton: FC<{ url: string; text: string }> = ({ url, text }) => {
  const location = useLocation();
  const style = useMemo(
    () => getButtonSxByPath(location.pathname, url),
    [url, location.pathname],
  );

  return (
    <Link to={url} style={style}>
      <Button color="inherit" sx={style}>
        {text}
      </Button>
    </Link>
  );
};

const Header = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'static',
        color: 'white',
        height: 64,
        backgroundColor: config.MainColor,
      }}
    >
      <Box
        display="flex"
        height="100%"
        paddingX={3}
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography
          sx={{ flexGrow: 1 }}
          variant="h6"
          color="inherit"
          component="div"
          onClick={() => navigate('/')}
        >
          Keep To Ship
        </Typography>

        <HeaderLinkButton url="/video" text="Video" />
        <HeaderLinkButton url="/presentation" text="Presentation" />
        <HeaderLinkButton url="/contact-us" text="Contact Us" />
      </Box>
    </Box>
  );
};

export default Header;
